


































































































































































































































































































































import { Subscription, SubscriptionsService } from '@/api/braendz';
import { BusyObject } from '@/models/Busy';
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

import Popup from '@/components/Popups/Popup.vue'
import SubscriptionState from '@/components/Account/SubscriptionState.vue'
import ConfirmationPopup from '@/components/Popups/ConfirmationPopup.vue'
import LoadingView from '@/components/Spinner/LoadingView.vue'

@Component({
    components: {
        Popup,
        SubscriptionState,
        ConfirmationPopup,
        LoadingView
    },
    model: {
        prop: "model",
        event: "visibilityChanged"
    }
})
export default class SubscriptionPopup extends Vue {
    public visibility = false;
        
    // Properties
    @Prop({ required: false })
    public model?: boolean;

    public showUnsubscribeConfirmation = false;

    // Getter & Setter
    public get visible(): boolean {
        return this.model ?? this.visibility;
    }
    public set visible(value: boolean) {
        this.visibility = value;
        this.$emit('visibilityChanged', value);
    }

    public get activeSubscription(): BusyObject<Subscription> {
        return this.$store.state.activeSubscription;
    }

    // Watcher

    // Lifecycle Methods:

    // Methods:
    public close(): void {
        this.visible = false;
    }

    public async unsubscribePayPal(): Promise<void> {
        this.$store.dispatch('unsubscribePayPal', this.$i18n.t('subscriptionPopup.cancellationReason').toString());
    }

    public async unsubscribeMarketplace(): Promise<void> {
        this.$store.dispatch('unsubscribeMarketplace');
    }

    public upgrade(): void {
        this.close();
        this.$router.push({name: 'Products', params: { lang: this.$i18n.locale }});
    }
}
